// pages/AgendaPage.js o donde desees usarlo
import React from 'react';
import { Box } from '@mui/material';
import MonitorAllManifest from '../../components/administration/manifests/MonitoringDashboard';

const MonitorViajePage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <MonitorAllManifest
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de Monitoreamiento de todos los viaje', newOrder);
                }}
            />
        </Box>
    );
};

export default MonitorViajePage;
